import { render } from "./TheItinerary.vue?vue&type=template&id=bf8b13bc"
import script from "./TheItinerary.vue?vue&type=script&lang=js"
export * from "./TheItinerary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__